import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  BusinessTypeIsForProfit,
  RelatedPartyRelationshipEqualsTo,
} from '../rules/';

import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

class PrincipalPercentOwnedRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const relatedPartyRelationshipIsPrincipal =
      RelatedPartyRelationshipEqualsTo.setRelationship(
        RELATED_PARTY_RELATIONSHIP.PRINCIPAL
      )
        .setPrincipalId(this.principalId)
        .evaluate(data);

    const businessTypeIsForProfit = BusinessTypeIsForProfit.evaluate(data);

    if (relatedPartyRelationshipIsPrincipal && businessTypeIsForProfit) {
      return RulesetResult.REQUIRED;
    }

    return RulesetResult.HIDDEN;
  };
}

export default new PrincipalPercentOwnedRuleset();
